export default __webpack_public_path__ + "static/media/ukiyo-egirls.a22c992e.gif";